// Keyboard shortcut: Cmd/Ctrl+Enter submits the form holding the focused field.
document.addEventListener("keydown", (event) => {
  if (!(event.metaKey || event.ctrlKey) || event.key !== "Enter") return

  const focused = document.activeElement
  const form = focused && focused.closest ? focused.closest("form") : null
  if (!form) return

  event.preventDefault()
  if (typeof form.requestSubmit === "function") {
    form.requestSubmit()
  } else {
    form.submit()
  }
})
